import React, { useContext } from "react";
import classes from "./index.module.scss";
import Header from "components/Header";
import { Breadcrumb } from "antd";
import { Link } from "react-router-dom";
import classNames from "classnames";
import { CourseContext } from "../../Store";

interface DetailLayoutProps {
    children: React.ReactNode;
    breadcrumb?: React.ReactNode;
}

export default function DetailLayout({
    children,
    breadcrumb
}: DetailLayoutProps) {
    const { basename } = useContext(CourseContext);

    return (
        <div className={classNames(classes.root, "PopupContainer")}>
            <Header />

            <div className={classes.main}>
                <Breadcrumb separator=">">
                    <Breadcrumb.Item>
                        <Link to="/" replace>
                            首页
                        </Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>
                        <Link to={`${basename}/resource`} replace>
                            课程内容
                        </Link>
                    </Breadcrumb.Item>

                    {typeof breadcrumb === "string" ? (
                        <Breadcrumb.Item>{breadcrumb}</Breadcrumb.Item>
                    ) : (
                        breadcrumb
                    )}
                </Breadcrumb>

                <div className={classes.body}>{children}</div>
            </div>
        </div>
    );
}
